// Canvas type ("nature") values. Normal is the absence of a value ("").
/** @type {"wH"} */
export const WINDOW_HEIGHT = "wH";
/** @type {"dH"} */
export const GROW_WITH_CONTENT = "dH";
/** @type {"scrollingViews"} */
export const SCROLLING_VIEWS = "scrollingViews";

// Scrolling views "spacing" values. Absent means condensed.
/** @type {"condensed"} */
export const SPACING_CONDENSED = "condensed";
/** @type {"window"} */
export const SPACING_WINDOW = "window";
